import React from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { RDSAccessPolicies } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/AccessPolicies/RDS/RDSAccessPolicies';
import { S3AccessPolicies } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/AccessPolicies/S3AccessPolicies';
import { SnowflakeDatabaseAccessPolicies } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/AccessPolicies/SnowflakeDatabaseAccessPolicies';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

export const AccessPoliciesTab = () => {
  const { resourceType } = useSelector(selectActiveResource);

  const getAccessPolicies = () => {
    switch (resourceType) {
      case NativeResources.RelationalDatabaseService:
        return <RDSAccessPolicies />;
      case NativeResources.SimpleStorageService:
        return <S3AccessPolicies />;
      case NativeResources.SnowflakeDatabases:
        return <SnowflakeDatabaseAccessPolicies />;
    }
  };

  return (
    <Box h="full" w="full">
      {getAccessPolicies()}
    </Box>
  );
};
